export default __webpack_public_path__ + "static/media/logo__technology__mongo.31728036.png";